import { ArchiveAlertIcon } from './ArchiveAlertIcon';

/**
 * author: Austin Andrews
 * id 41367FBC-DCE3-4202-AF33-3AD576C3FD7C
 * name archive-alert
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-alert.svg
 * tags
 * - Alert / Error 
 */
export const BoxAlertIcon = ArchiveAlertIcon;
export default BoxAlertIcon